import React from "react";
import "./PurchasedItemsGallery.css"; // Import du fichier CSS

const items = [
    { id: 2, name: "Fourrures", image: "/images/IMG_20250301_154744.png" },
    { id: 5, name: "Argenterie", image: "/images/IMG_20250301_154854.png" },
    { id: 3, name: "Maroquinerie", image: "/images/IMG_20250301_154905.png" },
    { id: 1, name: "Bijoux", image: "/images/IMG_20250301_154906.png" },
    { id: 4, name: "Pièces de Monnaie", image: "/images/IMG_20250301_154901.png" },
];

const PurchasedItemsGallery = () => {
    return (
        <div className="gallery-container">
            <h2 className="gallery-title">Objets que nous rachetons</h2>
            <div className="gallery-grid">
                {items.map((item) => (
                    <div key={item.id} className="gallery-item">
                        <img src={item.image} alt={item.name} className="gallery-image" />
                        <p className="gallery-text">{item.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PurchasedItemsGallery;
